/**
 * Auto-generated index file for books
 * Generated from 5 book files
 */

import { Books } from '../types';
import { book9780879397012 } from './9780879397012';
import { book9780879397241 } from './9780879397241';
import { book9780879397616 } from './9780879397616';
import { book9780879398392 } from './9780879398392';
import { booksfd_basic_skills } from './sfd_basic_skills';

export const allBooks = new Books([
    book9780879397012,
    book9780879397241,
    book9780879397616,
    book9780879398392,
    booksfd_basic_skills,
]);

export default allBooks;
